import React from 'react';
import PropTypes from 'prop-types';
import { ValidatingSelect, ValidatingInput, Message, mapStateToProps } from '../../';
import { connect } from 'react-redux';
import Countries, { states } from '../../../constants/Countries';
import TaxInfoSchema from '../../../data/schema/TaxInfoSchema';
import { INDIVIDUAL_SOLE_PROPRIETOR, SSN, EIN, businessTypeOptions } from '../../../constants/PayoutConstants';

const statesOptions = states;

@connect(mapStateToProps)
export default class PaypalAccount extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        onChange: PropTypes.func,
        getValue: PropTypes.func,
        disabled: PropTypes.bool,
        formValues: PropTypes.object
    };

    getcountryOptions = () => {
        const foreignTaxValue = this.props.formValues.foreignTax;
        return foreignTaxValue ? Countries.slice(1) : [{ value: 'US', label: 'UNITED STATES' }];
    };

    getTaxTypeOptions = () => {
        const foreignTaxValue = this.props.formValues.foreignTax;
        const businessTypeValue = this.props.formValues.businessType;

        const isForeignTax = foreignTaxValue;
        let taxTypeOptions = [];
        if (isForeignTax) {
            taxTypeOptions = [
                { label: 'None', value: '' },
                { label: 'Value Added Tax (VAT)', value: 'VAT' },
                { label: 'Tax ID', value: 'TAXID' }
            ];
        } else {
            taxTypeOptions = [{ label: 'None', disabled: true, value: '' }];
            if (businessTypeValue === INDIVIDUAL_SOLE_PROPRIETOR) {
                taxTypeOptions.push({ label: 'Social Security Number (SSN)', value: SSN });
            } else {
                taxTypeOptions.push({ label: 'Employer Identification Number (EIN)', value: EIN });
            }
        }
        return taxTypeOptions;
    };

    getTaxTypeRequired = () => {
        const foreignTaxValue = this.props.formValues.foreignTax;
        const businessTypeValue = this.props.formValues.businessType;
        const isForeignTax = foreignTaxValue;
        return !(isForeignTax && businessTypeValue === INDIVIDUAL_SOLE_PROPRIETOR);
    };

    getPhoneNumberRequired = () => {
        const country = this.props.formValues.address.country;
        return country === 'KR';
    }

    render() {
        const { getValue, onChange, formValues, disabled } = this.props;
        const taxInfoSchema = new TaxInfoSchema(this.props.messages);

        const {
            address,
            businessName,
            businessType,
            city,
            country,
            foreignTax,
            nameOnTaxId,
            phoneNumber,
            postalCode,
            region,
            state,
            taxType,
            zip
        } = taxInfoSchema;

        const foreignTaxOptions = [
            { value: true, label: foreignTax.optionLabel.yes },
            { value: false, label: foreignTax.optionLabel.no }
        ];

        const foreignTaxValue = formValues.foreignTax;
        const taxTypeValue = formValues.taxType;
        const isForeignTax = foreignTaxValue;

        return (
            <div style={{ marginTop: '24px' }}>
                <h2>
                    <Message code="epic.esport.label.taxInfo" />
                </h2>
                <p>
                    <Message code="epic.esport.label.taxInfo_text" />
                </p>
                <div className="row">
                    <ValidatingSelect
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={foreignTax.identifier}
                        options={foreignTaxOptions}
                        value={getValue(foreignTax.identifier)}
                        onChange={onChange(foreignTax.identifier)}
                        validations={disabled ? {} : foreignTax.validations}
                        validationErrors={foreignTax.validationMessages}
                        disabled={disabled}
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={businessName.identifier}
                        value={getValue(businessName.identifier)}
                        placeholder={businessName.display.text}
                        onChange={onChange(businessName.identifier)}
                        validations={disabled ? {} : businessName.validations}
                        validationErrors={businessName.validationMessages}
                        required={businessName.required}
                        disabled={disabled}
                    />
                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={nameOnTaxId.identifier}
                        value={getValue(nameOnTaxId.identifier)}
                        placeholder={nameOnTaxId.display.text}
                        onChange={onChange(nameOnTaxId.identifier)}
                        validations={disabled ? {} : nameOnTaxId.validations}
                        validationErrors={nameOnTaxId.validationMessages}
                        required={nameOnTaxId.required}
                        disabled={disabled}
                    />

                    <ValidatingSelect
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={businessType.identifier}
                        options={businessTypeOptions}
                        value={getValue(businessType.identifier)}
                        onChange={onChange(businessType.identifier)}
                        validations={disabled ? {} : businessType.validations || {}}
                        validationErrors={businessType.validationMessages}
                        required={businessType.required}
                        disabled={disabled}
                    />

                    <ValidatingSelect
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={taxType.identifier}
                        options={this.getTaxTypeOptions()}
                        value={getValue(taxType.identifier)}
                        onChange={onChange(taxType.identifier)}
                        validations={disabled ? {} : taxType.validations || {}}
                        validationErrors={taxType.validationMessages}
                        required={this.getTaxTypeRequired()}
                        disabled={disabled}
                    />

                    {taxTypeValue && (
                        <ValidatingInput
                            customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                            name={taxInfoSchema[taxTypeValue].identifier}
                            value={getValue(taxInfoSchema[taxTypeValue].identifier)}
                            placeholder={taxInfoSchema[taxTypeValue].display.text}
                            onChange={onChange(taxInfoSchema[taxTypeValue].identifier)}
                            validations={disabled ? {} : taxInfoSchema[taxTypeValue].validations}
                            validationErrors={taxInfoSchema[taxTypeValue].validationMessages}
                            disabled={disabled}
                            required={true}
                        />
                    )}

                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={address.identifier}
                        value={getValue(address.identifier)}
                        placeholder={address.display.text}
                        onChange={onChange(address.identifier)}
                        validations={disabled ? {} : address.validations}
                        validationErrors={address.validationMessages}
                        required={address.required}
                        disabled={disabled}
                    />

                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={city.identifier}
                        value={getValue(city.identifier)}
                        placeholder={city.display.text}
                        onChange={onChange(city.identifier)}
                        validations={disabled ? {} : city.validations}
                        validationErrors={city.validationMessages}
                        required={city.required}
                        disabled={disabled}
                    />

                    {!foreignTaxValue // country is us
                        ? [
                            <ValidatingSelect
                                key="state"
                                customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                                name={state.identifier}
                                options={statesOptions}
                                value={getValue(state.identifier)}
                                onChange={onChange(state.identifier)}
                                disabled={disabled}
                            />,
                            <ValidatingInput
                                key="zip"
                                customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                                name={zip.identifier}
                                value={getValue(zip.identifier)}
                                placeholder={zip.display.text}
                                onChange={onChange(zip.identifier)}
                                validations={disabled ? {} : zip.validations}
                                validationErrors={zip.validationMessages}
                                required={zip.required}
                                disabled={disabled}
                            />
                        ]
                        : [
                            <ValidatingInput
                                key="region"
                                customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                                name={region.identifier}
                                value={getValue(region.identifier)}
                                placeholder={isForeignTax ? region.display.text : region.display.text_state}
                                onChange={onChange(region.identifier)}
                                validations={disabled ? {} : region.validations}
                                validationErrors={region.validationMessages}
                                required={region.required}
                                disabled={disabled}
                            />,
                            <ValidatingInput
                                key="postalCode"
                                customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                                name={postalCode.identifier}
                                value={getValue(postalCode.identifier)}
                                placeholder={postalCode.display.text}
                                onChange={onChange(postalCode.identifier)}
                                validations={disabled ? {} : postalCode.validations}
                                validationErrors={postalCode.validationMessages}
                                required={postalCode.required}
                                disabled={disabled}
                            />
                        ]}

                    <ValidatingSelect
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        name={country.identifier}
                        options={this.getcountryOptions()}
                        value={getValue(country.identifier)}
                        validations={disabled ? {} : country.validations}
                        validationErrors={country.validationMessages}
                        onChange={onChange(country.identifier)}
                        disabled={disabled}
                    />

                    <ValidatingInput
                        customClassNames="col-xs-12 col-md-8 col-lg-6 code-input"
                        disabled={disabled}
                        inputType="tel"
                        maxLength={17}
                        name={phoneNumber.identifier}
                        onChange={onChange(phoneNumber.identifier)}
                        placeholder={phoneNumber.display.text}
                        required={this.getPhoneNumberRequired()}
                        validationErrors={phoneNumber.validationMessages}
                        validations={disabled ? {} : phoneNumber.validations}
                        value={getValue(phoneNumber.identifier)}
                    />
                </div>
            </div>
        );
    }
}
